
import { Injectable } from "@angular/core";
import { AppHelper } from '@shared-helpers/app-helper';
import { DocumentTypeName } from "@global-enum/GeneralUtility";


@Injectable()
export class AgGridGlobalSettings {

    public static DateFormat(params) {
        return params.value ? (new Date(params.value)).toLocaleDateString() : '';
    }

    public static DateLocalFormat(params) {
        return params.value ? (new Date(params.value)).toLocaleString() : '';
    }

    public static GetGridHistoyIcon(icon?: string, title?: string) {

        icon = AppHelper.IsNullOrEmpty(icon) ? 'history' : icon;
        title = AppHelper.IsNullOrEmpty(title) ? 'Tarihçe' : title;
        return this.GetGridIcon(icon, title);
    }

    public static GetGridWorkflowStatusIcon(icon?: string, title?: string) {

        icon = AppHelper.IsNullOrEmpty(icon) ? 'share-alt' : icon;
        title = AppHelper.IsNullOrEmpty(title) ? 'Onay Durumu' : title;
        return this.GetGridIcon(icon, title);
    }

    public static GetGridDeleteIcon(icon?: string, title?: string) {

        icon = AppHelper.IsNullOrEmpty(icon) ? 'trash' : icon;
        title = AppHelper.IsNullOrEmpty(title) ? 'Tarihçe' : title;
        return this.GetGridIcon(icon, title);
    }

    public static GetGridDisplayIcon(icon?: string, title?: string) {

        icon = AppHelper.IsNullOrEmpty(icon) ? 'clipboard' : icon;
        title = AppHelper.IsNullOrEmpty(title) ? 'Görüntüle' : title;
        return this.GetGridIcon(icon, title);
    }

    private static GetGridIcon(icon: string, title: string) {
        return '<span class="AgGridIcon" title="' + title + '"><i class="la la-' + icon + '"></i></span>';
    }

    public static PriceFormat(params) {
        return params.value ? AppHelper.priceViewFormat(params.value) : '';
    }

  public static GetColumnName(element: any) {

        if(!AppHelper.IsNullOrUndefined(element.Alias)){
            return element.Alias;
        }
        else{
            return element.ColumnName;
        }
    }

    public static ExcelDataTimeFormat(): string {
        return AppHelper.GetDateTimeFormat();
    }

    public static ExcelDateFormat(): string {
        return AppHelper.GetDateFormat();
    }

    public static DocumentTypeNameFormat(params) {
        if (params.value === 'EArchiveInvoice') {
            return DocumentTypeName.EarchiveReport;
        } else if (params.value === 'SmmReceipt') {
            return DocumentTypeName.SmmReceipt;
        } else if (params.value === 'Mustahsil') {
            return DocumentTypeName.Mustahsil;
        }

    }


}
